// extracted by mini-css-extract-plugin
module.exports = {"BaseContactForm":"BaseContactForm-module__BaseContactForm___3-7cP","spinner":"BaseContactForm-module__spinner___2IZpC"};